import React, { Component } from 'react'
import OneLineEditor from '../../../components/OneLineEditor'
import EstimationStore from '../../../libs/EstimationStore'
import EstimationActions from '../../../libs/EstimationActions'
import Utils from '../../../libs/Utils'
import Description1 from './LaborUnitPriceTab/Description1'
import Description2 from './LaborUnitPriceTab/Description2'
import SocialInsuranceUchiwake from './LaborUnitPriceTab/SocialInsuranceUchiwake'

class LaborUnitPriceTab extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: EstimationActions.getCurrentEstimation(),
      listener: null
    }
  }
  componentDidMount () {
    this.setState({
      listener: EstimationStore.addListener('change', () => {
        this.setState({
          data: EstimationActions.getCurrentEstimation()
        })
      })
    })
  }
  componentWillUnmount () {
    if (this.state.listener) this.state.listener.remove()
  }
  render () {
    const daikuLabor = EstimationActions.getLaborSharedValues('daiku')
    let daikuLaborUnitPriceType = daikuLabor.laborUnitPriceType
    let daikuGetsugaku = daikuLabor.getsugaku

    const kaitaiLabor = EstimationActions.getLaborSharedValues('kaitai')
    let kaitaiLaborUnitPriceType = kaitaiLabor.laborUnitPriceType
    let kaitaiGetsugaku = kaitaiLabor.getsugaku

    return (
      <div>
        <article className='kw-katawaku-art'>

          {/* <section className="kw-print-page">
          <div className="kw-container"> */}

          <div className='kw-overview'>
            <p className='kw-pad1 kw-clear'>型枠大工の報酬月額</p>

            <div className='kw-tbl'>
              <table>
                <thead>
                  <tr>
                    <th className='kw-name' />
                    <th className='kw-yen' />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>日額手取り賃金</th>
                    <td className={daikuLaborUnitPriceType === 'Tedori' ? 'kw-inputable' : ''}>
                      {daikuLaborUnitPriceType === 'Tedori' ? <OneLineEditor bindingDataAttribute='daikuLaborTedoriUnitPrice' prefix='¥' isNum textAlign='right' isCommaSeparated callback={EstimationActions.updateLaborUnitPrice} />
                      : Utils.convKingaku(this.state.data.daikuLaborTedoriUnitPrice)}
                    </td>
                  </tr>
                  <tr>
                    <th>日額賃金(本人負担含む)</th>
                    <td className={daikuLaborUnitPriceType === 'Honnin' ? 'kw-inputable' : ''}>
                      {daikuLaborUnitPriceType === 'Honnin' ? <OneLineEditor bindingDataAttribute='daikuLaborHonninUnitPrice' prefix='¥' isNum textAlign='right' isCommaSeparated
                        callback={EstimationActions.updateLaborUnitPrice} />
                      : Utils.convKingaku(this.state.data.daikuLaborHonninUnitPrice)}
                    </td>
                  </tr>
                  <tr>
                    <th>法定福利費込み日額人件費</th>
                    <td className={daikuLaborUnitPriceType === 'Hukuri' ? 'kw-inputable' : ''}>
                      {daikuLaborUnitPriceType === 'Hukuri' ? <OneLineEditor bindingDataAttribute='daikuLaborHukuriUnitPrice' prefix='¥' isNum textAlign='right' isCommaSeparated
                        callback={EstimationActions.updateLaborUnitPrice} />
                      : Utils.convKingaku(this.state.data.daikuLaborHukuriUnitPrice)}
                    </td>
                  </tr>
                  <tr>
                    <th>公共工事設計労務単価</th>
                    <td className={daikuLaborUnitPriceType === 'Sekkei' ? 'kw-inputable' : ''}>
                      {daikuLaborUnitPriceType === 'Sekkei' ? <OneLineEditor bindingDataAttribute='daikuLaborSekkeiUnitPrice' prefix='¥' isNum textAlign='right' isCommaSeparated callback={EstimationActions.updateLaborUnitPrice} />
                      : Utils.convKingaku(this.state.data.daikuLaborSekkeiUnitPrice)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>{/* <!-- .kw-tbl --> */}
            <div className='kw-tbl2'>
              <table>
                <thead>
                  <tr>
                    <th className='kw-name' />
                    <th className='kw-yen' />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>平均労務日数</th>
                    <td className='text-right kw-inputable'><OneLineEditor bindingDataAttribute='daikuLaborWorkDays' isNum suffix='日' textAlign='right' /></td>
                  </tr>
                  <tr>
                    <th>労務月額</th>
                    <td>
                      {Utils.convKingaku(daikuGetsugaku)}
                    </td>
                  </tr>
                  <tr>
                    <th>標準報酬月額</th>
                    <td>{Utils.convKingaku(EstimationActions.getHyouzyunGetsugaku(daikuGetsugaku, true))}</td>
                  </tr>
                </tbody>
              </table>
            </div>{/* <!-- .kw-tbl2 --> */}

            <p className='kw-pad1 kw-clear'>社会保険料内訳</p>
            <SocialInsuranceUchiwake laborType='daiku' />
            <p className='kw-space5 kw-clear' />

            <p className='kw-pad1 kw-clear'>用語・基礎数値の説明</p>

            <div style={{marginBottom: '10px'}}>
              <Description1 estimationType={this.state.data.estimationType} />
            </div>

          </div>{/* <!-- .kw-overview --> */}

          <div className='kw-overview'>
            <p className='kw-pad1 kw-clear'>型枠解体工の報酬月額</p>

            <div className='kw-tbl'>
              <table>
                <thead>
                  <tr>
                    <th className='kw-name' />
                    <th className='kw-yen' />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>日額手取り賃金</th>
                    <td className={kaitaiLaborUnitPriceType === 'Tedori' ? 'kw-inputable' : ''}>
                      {kaitaiLaborUnitPriceType === 'Tedori' ? <OneLineEditor bindingDataAttribute='kaitaiLaborTedoriUnitPrice' prefix='¥' isNum textAlign='right' isCommaSeparated callback={EstimationActions.updateLaborUnitPrice} />
                    : Utils.convKingaku(this.state.data.kaitaiLaborTedoriUnitPrice)}
                    </td>
                  </tr>
                  <tr>
                    <th>日額賃金(本人負担含む)</th>
                    <td className={kaitaiLaborUnitPriceType === 'Honnin' ? 'kw-inputable' : ''}>
                      {kaitaiLaborUnitPriceType === 'Honnin' ? <OneLineEditor bindingDataAttribute='kaitaiLaborHonninUnitPrice' prefix='¥' isNum textAlign='right' isCommaSeparated
                        callback={EstimationActions.updateLaborUnitPrice} />
                    : Utils.convKingaku(this.state.data.kaitaiLaborHonninUnitPrice)}
                    </td>
                  </tr>
                  <tr>
                    <th>法定福利費込み日額人件費</th>
                    <td className={kaitaiLaborUnitPriceType === 'Hukuri' ? 'kw-inputable' : ''}>
                      {kaitaiLaborUnitPriceType === 'Hukuri' ? <OneLineEditor bindingDataAttribute='kaitaiLaborHukuriUnitPrice' prefix='¥' isNum textAlign='right' isCommaSeparated
                        callback={EstimationActions.updateLaborUnitPrice} />
                    : Utils.convKingaku(this.state.data.kaitaiLaborHukuriUnitPrice)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>{/* <!-- .kw-tbl --> */}
            <div className='kw-tbl2'>
              <table>
                <thead>
                  <tr>
                    <th className='kw-name' />
                    <th className='kw-yen' />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>平均労務日数</th>
                    <td className='text-right kw-inputable'><OneLineEditor bindingDataAttribute='kaitaiLaborWorkDays' isNum suffix='日' textAlign='right' /></td>
                  </tr>
                  <tr>
                    <th>労務月額</th>
                    <td>{Utils.convKingaku(kaitaiGetsugaku)}</td>
                  </tr>
                  <tr>
                    <th>標準報酬月額</th>
                    <td>{Utils.convKingaku(EstimationActions.getHyouzyunGetsugaku(kaitaiGetsugaku, true))}</td>
                  </tr>
                </tbody>
              </table>
            </div>{/* <!-- .kw-tbl2 --> */}

            <p className='kw-space7 kw-clear' />

            <p className='kw-pad1 kw-clear'>社会保険料内訳</p>

            <SocialInsuranceUchiwake laborType='kaitai' />

            <p className='kw-space10 kw-clear' />

            <div style={{marginBottom: '10px'}}>
              <Description2 estimationType={this.state.data.estimationType} />
            </div>

          </div>{/* <!-- .kw-overview --> */}

          {/* </div> */}{/* <!-- .kw-container --> */}
          {/* </section> */}

        </article>
      </div>
    )
  }
}

export default LaborUnitPriceTab



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EstimationEdit/LaborUnitPriceTab.js